import { Injectable, inject } from '@angular/core';

import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { StaffNotification } from '@models/index';
import { NotificationType } from 'src/app/enumerates/notification/notification-type';

@Injectable({
    providedIn: 'root'
})
export abstract class NotificationBaseService {
    protected translateService = inject(TranslateService);

    abstract add(notification: StaffNotification): void;

    addTranslate(notification: StaffNotification): void {
        this.translateService.get([notification.description, notification.title]).pipe(take(1)).subscribe({ next: res => {
            this.add({
                description: res[notification.description],
                title: res[notification.title],
                type: notification.type,
                icon: notification.icon,
                class: notification.class
            });
        }});
    }

    showSuccessMessage(message = 'save_successful', title = 'success'): void {
        this.addTranslate({
            description: message,
            title,
            type: NotificationType.success,
            icon: 'checkmark-circle-outline',
            class: 'success-notification'
        });
    }

    addErrorMessage(message: string): void {
        this.addTranslate({
            description: message,
            title: 'error',
            type: NotificationType.error,
            icon: 'close-circle-outline',
            class: 'error-notification'
        });
    }
}
